import { render } from "./ProduitViews.vue?vue&type=template&id=64ef0f3e&scoped=true"
import script from "./ProduitViews.vue?vue&type=script&lang=js"
export * from "./ProduitViews.vue?vue&type=script&lang=js"

import "./ProduitViews.vue?vue&type=style&index=0&id=64ef0f3e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-64ef0f3e"]])

export default __exports__